import { render, staticRenderFns } from "./cardBorder.vue?vue&type=template&id=c52158bc&scoped=true"
import script from "./cardBorder.vue?vue&type=script&lang=js"
export * from "./cardBorder.vue?vue&type=script&lang=js"
import style0 from "./cardBorder.vue?vue&type=style&index=0&id=c52158bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52158bc",
  null
  
)

export default component.exports